import styled from 'styled-components';

export const StyledDocumentTemplateActionForm = styled.form`
   display: flex;
   flex-direction: column;
   gap: 18px;
`;

StyledDocumentTemplateActionForm.displayName = 'StyledDocumentTemplateActionForm';

export const StyledTabLabel = styled.span`
   display: inline-flex;
   align-items: flex-start;
   gap: 4px;
   padding-top: 2px;

   svg {
      width: 15px;
   }
`;

StyledTabLabel.displayName = 'StyledTabLabel';
